import { Pipe, PipeTransform } from '@angular/core';
import { SignUrlGQL } from 'src/app/generated/graphql';
import { lastValueFrom } from 'rxjs';

@Pipe({
    name: 'signUrl',
    standalone: true
})
export class SingUrlPipe implements PipeTransform {

  constructor(
    private signUrl: SignUrlGQL
  ) {}

  async transform(value: string): Promise<string> {
    if (value) {
      const observable = this.signUrl.fetch({
        url: value
      });

      const result = await lastValueFrom(observable);
      const signedUrl = result.data.signUrl?.signed;
      return signedUrl || '';
    } else {
      return '';
    }
  }
}